import { render, staticRenderFns } from "./AsideCore.vue?vue&type=template&id=1193d305&scoped=true"
import script from "./AsideCore.vue?vue&type=script&lang=js"
export * from "./AsideCore.vue?vue&type=script&lang=js"
import style0 from "./AsideCore.vue?vue&type=style&index=0&id=1193d305&prod&lang=scss&scoped=true"
import style1 from "./AsideCore.vue?vue&type=style&index=1&id=1193d305&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1193d305",
  null
  
)

export default component.exports